export default __webpack_public_path__ + "static/media/groupe-renault.a176b4be.png";